module.exports = __webpack_public_path__ + "static/img/sxjz.f4ddb68f.png";